import jStat from 'jstat';
import type { TwoArrayParams } from './types';

export interface CoefficientOfDeterminationResult {
  rSquared: number;
  rSquaredAdjusted: number;
  sampleSize: number;
  data1: number[];
  data2: number[];
  xLabel: string;
  yLabel: string;
}

/**
 * Calculates the coefficient of determination (R²) and adjusted R²
 * @param params Object containing two arrays of data
 * @returns Object containing R², adjusted R², sample size, and the original data
 */
export function calculateCoefficientOfDetermination({ data1, data2 }: TwoArrayParams): CoefficientOfDeterminationResult {
  if (data1.length !== data2.length) {
    throw new Error('Arrays must have the same length');
  }

  const sampleSize = data1.length;
  
  // Calculate R² using correlation coefficient
  const correlationCoefficient = jStat.corrcoeff(data1, data2);
  const rSquared = correlationCoefficient * correlationCoefficient;
  
  // Calculate adjusted R² 
  // Adjusted R² = 1 - [(1 - R²)(n-1)/(n-k-1)] where k is number of predictors (1 for simple linear regression)
  const rSquaredAdjusted = 1 - ((1 - rSquared) * (sampleSize - 1) / (sampleSize - 2));

  return {
    rSquared,
    rSquaredAdjusted,
    sampleSize,
    data1: Array.from(data1),
    data2: Array.from(data2),
    xLabel: '',  // Will be set by the calculator config
    yLabel: ''   // Will be set by the calculator config
  };
} 